import React from "react";
import { useTranslation } from "react-i18next";
import { InfoIcon } from "./icons";

export const HkiaAttribution: React.FC = () => {
  const { t } = useTranslation("flightAlerts");
  return (
    <div className="flex items-start gap-1.5">
      <InfoIcon className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-ink-40" />
      {/* Figma spec: Lexend Deca, Regular 400, 10px/14px, 0 letter-spacing,
          ink/55 (#0F151A8C) — same on mobile and desktop (DASH-6077).
          Required on every screen that shows a flight time; permanent, not
          dismissible, must not compete with the times. */}
      <span className="font-lexend text-[10px]/[14px] font-normal tracking-normal text-ink-55">
        {t("shared.hkiaAttribution")}
      </span>
    </div>
  );
};
